import { createAction } from 'redux-actions';
import {
  PapiGallection,
  PapiRequestDaSharedGallectionFoldersCreate,
  PapiRequestDaSharedGallectionFoldersUpdate,
} from '@wix/da-papi-types';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const fetchNextGallerySubfolders = createCallbackActionCreator(
  'NEXT_STUDIO_GALLERY_SUBFOLDERS'
);

export const createFolder = createAction(
  'STUDIO.CREATE_FOLDER',
  (
    data: Partial<PapiRequestDaSharedGallectionFoldersCreate> & {
      addToShortcuts: boolean;
      description?: any;
    },
    onSaveSuccess: (folderId: number) => void
  ) => ({ data, onSaveSuccess })
);

export const updateFolder = createAction(
  'STUDIO.UPDATE_FOLDER',
  (payload: {
    folderId: number;
    data: Partial<PapiRequestDaSharedGallectionFoldersUpdate> & {
      addToShortcuts?: boolean;
      description?: any;
    };
    doReload?: boolean;
    onSaveSuccess: (folderId: number) => void;
    onError?: () => void;
  }) => payload
);

export const fetchFolder = createAction(
  'STUDIO.FETCH_FOLDER',
  (
    folderId: number,
    folderType: PapiRequestDaSharedGallectionFoldersUpdate['type'],
    onFetchSuccess: (folder: PapiGallection) => void
  ) => ({
    folderId,
    folderType,
    onFetchSuccess,
  })
);

export const confirmDeleteFolder = createAction(
  'STUDIO.CONFIRM_DELETE_FOLDER',
  (folder: PapiGallection, onDeleteSuccess: () => void) => ({
    folder,
    onDeleteSuccess,
  })
);

export const deleteFolder = createAction(
  'STUDIO.DELETE_FOLDER',
  (folder: PapiGallection, onDeleteSuccess: () => void) => ({
    folder,
    onDeleteSuccess,
  })
);

export const updateFolderOrder = createAction(
  'STUDIO.UPDATE_FOLDER_ORDER',
  (folder: PapiGallection, position: number) => ({ folder, position })
);

export const moveFolderUp = createAction('STUDIO.MOVE_FOLDER_UP', (folder: PapiGallection) => ({
  folder,
}));

export const moveDeviationsToFolder = createAction(
  'STUDIO.MOVE_DEVIATIONS_TO_FOLDER',
  (deviationIds: number[], targetFolderId: number) => ({
    deviationIds,
    targetFolderId,
  })
);

export const moveSelectionToFolder = createAction(
  'STUDIO.MOVE_SELECTION_TO_FOLDER',
  (targetFolderId: number) => ({ targetFolderId })
);

export const confirmMoveSelectionToFolder = createAction(
  'STUDIO.CONFIRM_MOVE_SELECTION_TO_FOLDER',
  (targetFolderId: number) => ({ targetFolderId })
);

export const copyFolderLink = createAction('STUDIO.COPY_FOLDER_LINK', (folder: PapiGallection) => ({
  folder,
}));

export const createFolderFromSelection = createAction(
  'STUDIO.CREATE_FOLDER_FROM_SELECTION',
  () => ({})
);

export const updateSelectedFolder = createAction(
  'STUDIO.UPDATE_SELECTED_FOLDER',
  (folder: PapiGallection) => ({ folder })
);

export const reloadSelectedFolder = createAction('STUDIO.RELOAD_SELECTED_FOLDER', () => ({}));

export const setIsBusy = createAction('STUDIO.FOLDERS_SET_IS_BUSY', (isBusy: boolean) => ({
  isBusy,
}));

export const reloadSubfolders = createAction('STUDIO.RELOAD_SUBFOLDERS', (type: string) => ({
  type,
}));
